/**
 * Logger utility that only outputs in development mode
 * Use this instead of console.log throughout the application
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]): void => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]): void => {
    // Always show errors, even in production
    console.error(...args);
  },
  info: (...args: unknown[]): void => {
    if (isDev) console.info(...args);
  },
  debug: (...args: unknown[]): void => {
    if (isDev) console.debug(...args);
  },
  group: (label: string): void => {
    if (isDev) console.group(label);
  },
  groupEnd: (): void => {
    if (isDev) console.groupEnd();
  },
  table: (data: unknown): void => {
    if (isDev) console.table(data);
  },
};

export default logger;
